import React, { Component } from "react";
// import ItemHp from "../../../components/ItemHp/ItemHp";
// import Hammer from "hammerjs";

import "./Homepage.scss";
import { newsHp } from "../../../api/news";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getInterstitials } from "../../../api/interstitials";
import { createIndexDB } from "utils/indexDb_Helper";
import { setNews, resetNews } from "../../../store/actions/newsActions";
import Interstitials from "../../../components/Interstitials/Interstitials";
import ItemList from "./ItemList";

class Homepage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      lng: this.props.i18n.language,
      handleOpeningInterstitial: false,
      interstitialData: {},
      isindexDbUpdated: false,
    };
  }

  componentDidMount() {
    this._getNews();
    this.initInterstitial();
  }

  componentDidUpdate(prevProps) {
    if (this.state.lng !== this.props.i18n.language) {
      this.setState({ lng: this.props.i18n.language });
      this._getNews();
    }

    if ((!this.state.isindexDbUpdated ||
      prevProps?.auth?.access_token !== this.props.auth.access_token)
      && this.props?.auth.access_token) {
      this.setState({ isindexDbUpdated: true });
      createIndexDB(this.props.auth.access_token);
    }
  }

  initInterstitial() {
    getInterstitials()
      .then((data) => {
        if (data.length > 0) {
          this.setState({ interstitialData: data });
          this.setState({ handleOpeningInterstitial: true });
        }
        return this.setState({ interstitialData: data });
      })
      .catch((err) => console.log(err));
  }

  setOpeningInterstitial = (link) => {
    this.setState(
      { handleOpeningInterstitial: !this.state.handleOpeningInterstitial },
      () => {
        // if link does not start with either http or https, add https
        const finalLink = link.startsWith("http") ? link : `https://${link}`;
        window.location.href = finalLink;
      }
    );
  };
  setOpening = () => {
    this.setState({
      handleOpeningInterstitial: !this.state.handleOpeningInterstitial,
    });
  };

  _getNews() {
    this.setState({ loading: true });
    newsHp()
      .then((data) => {
        const dataItems = data.map((elem, index) => ({
          ...elem,
          // picture: "https://picsum.photos/600/300",
          size: index > 0 ? 0 : 1,
        }));
        // const dataCopy = [...dataItems, ...dataItems];
        // this.props.setNews(dataCopy);
        this.props.setNews(dataItems);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    return (
      <>
        {this.state.handleOpeningInterstitial && (
          <Interstitials
            interstitialData={this.state.interstitialData}
            handleOpeningLink={(link) => this.setOpeningInterstitial(link)}
            handleOpening={this.setOpening}
          />
        )}
        <div id="items_slider container-width">
          {this.props.news.items?.length > 0 && !this.state.loading && (
            <ItemList
              key={this.props.news.items}
              items={this.props.news.items}
            />
          )}
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setNews: (products) => {
      dispatch(setNews(products));
    },
    resetNews: () => {
      dispatch(resetNews());
    },
  };
};

//extract data from the redux store
const mapStateToProps = (state) => ({
  news: state.news,
  idInterstitial: state.idInterstitial,
  auth: state?.auth,
  state1: state,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Homepage));
